<template>
  <div :id="key_id" class="mb-3">
    <div class="d-flex justify-content-between align-items-center flex-wrap">
        <div class="mb-2">
          <div class="h3-like">{{params.group.public_name}}</div>
          <small>
            {{nights}}
            <span class="text-muted">{{from_date}}</span>
          </small>
        </div>

        <b-button class="mb-2" variant="light" size="sm"
                  v-if="is_ready && !is_nothing_to_choose"
                  @click="change_state_to('choosing')"
        >
          изменить выбор
        </b-button>

    </div>

    <div class="box" v-if="!inherited && (shown_combinations.length == 0) && (combinations.length > 0)">
      <div class="box-content">
        К сожалению, в рамках данного тура невозможно разместить указанное количество туристов в одном номере.
        <br>
        <br>
        Посмотрите возможные комбинации номеров или отправьте заявку.
        <br>
        <br>
        <b-button class="mb-2" variant="secondary" size="sm"
                  @click="change_list_state_to('all')"
        >
          Показать комбинации номеров
        </b-button>

      </div>
    </div>

    <div class="box" v-if="inherited && (shown_combinations.length == 0)">
      <div class="box-content">
        Выберите размещение в основной группе
      </div>
    </div>

    <template v-for="(combination, index) in shown_combinations">
        <transition name="fade-simple">
            <tour-placement-combination-item v-if="is_visible(index)"
                                             :combination="combination"
                                             :main_group="params.group.main"
                                             :index="index"
                                             :key="index"
                                             :readonly="inherited"
                                             :discount="discount"
                                             :discount_type="discount_type"
                                             :selected="is_selected(index)"
                                             @select="select_combination"
            />
        </transition>
    </template>
  </div>
</template>
<script>
import TourPlacementCombinationItem from "./TourPlacementCombinationItem";
import {pluralize} from "../../../components/shared/helpers";
import {scrollTo} from "../../../components/shared/page_scroll_helpers";
import moment from 'moment';

export default{
  components: {TourPlacementCombinationItem},
  props: {
    params: Object,
    start_date: [String, Date],
    index: Number,
    inheritance: Array,
    discount: Number,
    discount_type: String,
  },
  data(){
    return {
      combinations: [],
      choosed_combination_index: null,
      choosed_combination: null,
      inheritance_arr: this.inheritance,
      state: 'choosing',
      inherited: this.params.group.inherited,
      group_id: this.params.group.id,
      list_state: 'single',
    }
  },
  computed: {
    key_id(){
      return `hotel-group-${this.index}`
    },
    shown_combinations(){
      return (this.list_state === 'all' || this.inherited) ? this.rooms_combinations : this.single_combinations;
    },
    nights(){
      const nights = this.params.group.nights;
      return (nights == 0) ? '' : `${nights} ${pluralize(nights, 'ночь', 'ночи', 'ночей')}`;
    },
    from_date(){
      const date = moment(this.start_date).add(this.params.group.shift_days, 'days').format('LL');
      return `c ${date}`
    },

    // убираем комбинации в которых комбинируются несколько разных номеров.
    single_combinations(){
      return _.filter(this.combinations, (el) => {
        if (el.placements[1]) {
          return false
        } else {
          return el.placements[0].quantity > 1 ? false : true;
        }
      })
    },

    // исключаем комбинации с количеством людей больше одного
    rooms_combinations(){
      return _.filter(this.combinations, (el) => {
              return this.check_combination_filter(el);
            });
    },
    is_choosing(){
      return this.state === 'choosing';
    },
    is_ready(){
      return this.state === 'ready';
    },
    is_nothing_to_choose(){
      return this.single_combinations.length === 0
          ? this.combinations.length === 1
          : this.single_combinations.length === 1;
    },
  },
  watch:{
    inheritance(new_array){
      // this.$set(this, 'inheritance_arr', new_array);
      this.set_combinations();
    },
  },
  beforeMount() {
    this.set_combinations();
    if (this.is_nothing_to_choose) this.auto_choosing();
  },
  beforeUpdate() {
    this.set_combinations();
    if (this.is_nothing_to_choose) this.auto_choosing();
  },
  methods: {

    // отфильтровываем комбинации по согласованным параметрам.
    // более 1 туриста - исключаются рамещения с подселением
    check_combination_filter(combination){
      let min_rooms_quantity = 2,
          rooms_limit = Math.max(Math.floor(combination.person_quantity / 2), min_rooms_quantity);


      return (
          (
            // один турист
            (combination.person_quantity == 1) ||
            (
               // более 1 туриста - исключаются рамещения с подселением
               (combination.person_quantity > 1) && !combination.has_shared
            )
          ) &&
          // количество номеров должно быть не более половины количества туристов
          // (например 6 туристов, значит не более 3х номеров. Все комбинации, где номеров больше, исключаются).
          ( combination.rooms_quantity <= rooms_limit )
      );
    },
    auto_choosing(){
      this.select_combination(0, this.shown_combinations[0]);
    },
    set_combinations(){
      // console.log('SET COMBOS!!', this.index);
      if (this.inherited){
        if (this.inheritance.length > 0){
          let combo = _.find(this.inheritance, {group_id: this.group_id});
          if (combo) {

            this.$set(this, 'combinations', [combo.combo])
          } else {
            console.error('Combination not found.')
          }
        } else {
          console.error('Inheritance is empty.')
        }
      } else {
        // console.log('Set group combinations.')
        this.$set(this, 'combinations', this.params.combinations)
      }
    },
    // combos_sorted_by_price(combos){
    //   return _.orderBy(combos, [''])
    // },
    is_selected(index){
      return this.choosed_combination_index === index;
    },
    is_visible(index){
      return this.is_choosing || this.is_selected(index);
    },
    change_state_to(new_state){
      this.$set(this, 'state', new_state);
    },
    change_list_state_to(new_state){
      this.$set(this, 'list_state', new_state);
    },
    select_combination(index, combo){
      this.$set(this, 'choosed_combination_index', index);
      this.$set(this, 'choosed_combination', combo);
      this.change_state_to('ready');
      this.$emit('choose', combo, this.params.group);
      // scroll to top of form
      scrollTo('select_tour', -50);
    },
  }

}
</script>

<style>
.fadee-enter-active, .fadee-leave-active {
  transition: opacity .5s;
}
.fadee-enter, .fadee-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
